import apiWardsListCall from 'apps/investcore/apiCalls/wards/list';
import { DataTable } from 'common/data-table';
import ErrorMessage from 'common/ui/ErrorMessage';
import InfoCard from 'common/ui/info-card';
import { useFetchApiList } from 'hooks/api';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { linkCell } from 'utils/cell-formatter';
import { formatDateTime, formatISODate } from 'utils/formatDate';

const wardColumns = () => [
  {
    accessorKey: 'id',
    header: 'ID',
    cell: ({ getValue }) => linkCell({ getValue, path: '/admin/wards' }),
  },
  {
    accessorKey: 'name',
    header: 'Name',
  },
  {
    accessorKey: 'created_at',
    header: 'Created',
    meta: { className: 'text-right' },
    cell: ({ getValue }) => formatISODate(getValue()),
  },
];

const ItemDetail = ({ item }) => {
  const { created_at, fmarket_id, id, name, ordering, address_version, updated_at } = item || {};

  const { data: wards, error: wardsError, load: loadWards } = useFetchApiList(apiWardsListCall, {
    resourceName: 'data',
  });

  useEffect(() => {
    if (id) loadWards({ province_id: id, page_size: 99 });
  }, [id]);

  return (
    <div className="space-y-4">
      <div className="space-y-4">
        {/* Basic Information */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <InfoCard label="ID" value={id} />
          <InfoCard label="Name" value={name} />
          <InfoCard label="Ordering" value={ordering} />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <InfoCard label="FMarket ID" value={fmarket_id} />
          <InfoCard label="Address Version" value={address_version} />
        </div>
      </div>

      {/* Wards list — only shown for v2 provinces */}
      {address_version === 'v2' && (
        <>
          <h3 className="text-base font-medium text-gray-800 pt-2 border-b">
            Danh sách Phường/Xã ({wards?.length ?? 0})
          </h3>
          {wardsError ? (
            <ErrorMessage errors={wardsError} />
          ) : (
            <div>
              <DataTable
                noViewOptions
                containerClassName="max-h-[40vh]"
                data={wards || []}
                columns={wardColumns()}
              />
              <div className="flex justify-center text-sm font-medium py-2">
                <Link to={`/admin/wards?province_id=${id}`}>
                  Xem tất cả
                </Link>
              </div>
            </div>
          )}
        </>
      )}

      {/* Metadata Section */}
      <div className="bg-gray-50 -mx-6 -mb-6 p-6 rounded-b-lg mt-4 space-y-4">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          <InfoCard label="Created At" value={formatDateTime(created_at)} />
          <InfoCard label="Updated At" value={formatDateTime(updated_at)} />
        </div>
      </div>
    </div>
  );
};

export default ItemDetail;
